// extracted by mini-css-extract-plugin
export default {"sidebar":"Administrator_sidebar__fMbry"};